module.exports = __webpack_public_path__ + "img/HomePEC8000.4c6832ff.jpg";